import React from 'react';
import DefaultThresholdList from './components/DefaultThresholdList';

const DefaultThresholdView = () => (
  <DefaultThresholdList />
);

export default DefaultThresholdView;
